<app-sidebar-nav-items
  class="nav"
  [items]="navItemsArray">
</app-sidebar-nav-items>
